module.exports = __webpack_public_path__ + "static/media/smartmockupsHome.8a227553.jpeg";